/*
 * @Author: liyibo
 * @Email: liyibo.puck@bytedance.com
 * @Describe: 生成device_id，作为设为唯一标识
 * @document: https://bytedance.feishu.cn/docs/doccn4P2DQH6QT1lRxCKYlqDgMb
 */
const { v4: uuidv4 } = require('uuid')

;(function (root) {
  var key = 'oceanengine_bp_device_id'
  var deviceId = window.localStorage.getItem(key)
  if (!deviceId) {
    deviceId = uuidv4() || ''
    window.localStorage.setItem(key, deviceId)
  }
  root.deviceId = deviceId
})(window)
